import type { IAccesses, IUser } from "./types";

export default class User implements IUser {
  readonly id: string;
  readonly name: string;
  readonly email: string;
  readonly username: string;
  readonly avatar?: string;
  readonly avatarThumb?: string;
  readonly permissions: string[];
  readonly roles: { name: string }[];
  readonly accesses: IAccesses;

  constructor(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.email = data.email;
    this.username = data.username;
    this.avatar = data.avatar;
    this.avatarThumb = data.avatar_thumb;
    this.permissions = data.permissions;
    this.roles = data.roles;
    this.accesses = data.accesses;
  }
}
